import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPickSessionLotRequirements = {
  name: "getPickSessionLotRequirements" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  // Product ids on this session whose picks require a picker-entered lot.
  output: z.object({ productIds: z.array(z.string()) }),
};
